import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calender from "../assets/images/calendar.png";
import axios from "axios";
import {
  ADD_PASSENGER_URI,
  GET_STATE_URI,
  GET_DRIVER_LIST,
  GET_ALL_PAYER,
} from "../constant";
import { Circles } from "react-loader-spinner";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../messageBox/customSweetAlert";
import { InputMask } from "primereact/inputmask";
import SaveButton from "../components/buttons/SaveButton";
import CancelButton from "../components/buttons/CancelButton";
import {
  currentDateFormat,
  restrictZipInput,
  allowOnlyNumberKey,
} from "../utils";
import { passengerFormValidation } from "../validation/Validation";
import { useNavigate } from "react-router-dom";
import Calender from "../components/Calendar";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import Loader from "../components/loader/Loader";

// import Auto from '../components/Auto'

const Passenger = () => {
  const datepickerRef = useRef(null);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  let currentInputIndex = 0;
  const navigate = useNavigate();
  const checkboxRef = useRef(null);
  const [birthDate, setBirthDate] = useState();
  const [startDate, setStartDate] = useState();
  const [stateData, setStateData] = useState([]);
  const [userData, setUserData] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  //const [loading, setLoading] = useState(false);
  const [isAddingPassenger, setIsAddingPassenger] = useState(false);
  const inputRef = useRef(null);
  const formRef = useRef({});
  const [myArray, setMyArray] = useState([]);
  const [driverDetails, setDriverDetails] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [errors, setErrors] = useState({});
  const [passengerDetails, setPassengerDetails] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    preferred_name: "",
    gender: "",
    driverIds: [],
    insurance_number: "",
    pmi_number: "",
    payer: "",
    city: "",
    location: "",
    address_line_one: "",
    address_line_two: "",
    state: "",
    zip: "",
    date_of_birth: "",
    home_phone: "",
    cell_phone: "",
    pick_phone: "",
    alternative_phone: "",
    email_address: "",
    username: "",
    password: "",
    home_type: "",
    mode: "",
    weight: "",
    wc_expiry_date: "",
    oxy_yes: "",
    oxy_no: "",
    bari_yes: "",
    bari_no: "",
    e_first_name: "",
    e_last_name: "",
    e_cell_number: "",
    e_email: "",
    r_first_name: "",
    r_last_name: "",
    r_cell_number: "",
    r_email: "",
    diagnosis_code: "Z00.8",
  });
  const [payerList, setPayerList] = useState([]);
  const [addUsernamePassword, setAddUsernamePassword] = useState(false);

  const handleAddUsernamePasswordChange = (e) => {
    const checked = e.target.checked;
    setAddUsernamePassword(checked);
    if (!checked) {
      setPassengerDetails((prev) => ({
        ...prev,
        email_address: "",
        username: "",
        password: "",
      }));
      setErrors((prev) => {
        const next = { ...prev };
        delete next.email_address;
        delete next.username;
        delete next.password;
        return next;
      });
    }
  };

  async function handleFormSubmit(e) {
    e.preventDefault();
    const isValid = passengerFormValidation(passengerDetails, {
      requireUsernamePassword: addUsernamePassword,
    });
    setErrors(isValid);
    //console.log("calender:",passengerDetails);
    //return false;
    if (Object.keys(isValid).length === 0) {
      try {
        dispatch(setLoading(true));
        setIsAddingPassenger(true);

        const response = await axios.post(ADD_PASSENGER_URI, passengerDetails);

        //console.log(response.data.status);
        if (response.data.status === "200") {
          navigate("list");
          // setLoading(false);
          Swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          //console.log(response.data.msg);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.data.message,
            icon: "Error",
            confirmButtonText: "OK",
          });
          //console.log(response.data.message);
        }
      } catch (error) {
        console.error("Error logging in:", error);
      } finally {
        dispatch(setLoading(false));
        setIsAddingPassenger(false);
      }
    }
  }
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userData"));
    setUserData(data);
    const loadUser = async () => {
      const response = await axios.get(GET_DRIVER_LIST);
      const response_state = await axios.get(GET_STATE_URI);
      const response_payer = await axios.get(GET_ALL_PAYER);
      //console.log("driver",response.data);
      setStateData(response_state.data);
      setDriverDetails(response.data);
      setPayerList(response_payer.data);
    };

    loadUser();
  }, []);
  //console.log(driverDetails);

  //   const generateInput = (e)=> {
  //     let inputcount = document.getElementsByName('e_name').length+1;
  //     e.preventDefault();
  //     const input = document.createElement('input');
  //     input.type = 'text';
  //     input.setAttribute('data-index',formRef.current.querySelectorAll('.my-3').length);
  //     input.classList.add('form-control', 'my-3');
  //     input.name = 'e_name';
  //     input.setAttribute('autocomplete', 'off');
  //     input.id='driver_' + inputcount;
  //     input.addEventListener('keyup', onChangeHandler);
  //     input.addEventListener('change', handleInputChange);
  //     document.getElementById('inputs-section2').appendChild(input);

  //   }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    //console.log(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    setPassengerDetails((prev) => {
      return {
        ...prev,
        [name]: value,
        //date_of_birth: `${birthDate.getDate()}/${birthDate.getMonth() + 1}/${birthDate.getFullYear()}`,
        driverIds: Array.from(formRef.current.querySelectorAll(".my-3")).map(
          (input) => input.value,
        ),
      };
    });
  };
  // const handleHiddenInputChange=(e)=>{
  //     console.log(formRef.current.querySelectorAll('.user_id'));
  //     setPassengerDetails((prev)=>{
  //         return{
  //             ...prev,
  //         userId:  Array.from(formRef.current.querySelectorAll('.user_id')).map((input) => input.value  ),
  //        //Ids:  inputRef.current.dataset.code
  //         }
  //     });
  // }
  // const onSuggestHandler = (text,id) => {
  //     //console.log('haiii-',driverDetails);
  //     currentInputIndex= localStorage.getItem('InputIndex') || 0;
  //     const driverDetails=passengerDetails.driverIds.map((value,index)=>{
  //         if(index == currentInputIndex)
  //             {
  //              return {text,id};}
  //          else{ return value; }
  //     });

  //     setMyArray((prevData) => {
  //         return [...prevData, id]; // spread the previous array and add the new id
  //       });
  //       setPassengerDetails((prev)=>{
  //         return{
  //          ...prev,
  //          driverIds:  [...driverDetails],
  //         userIds: [...myArray, id]
  //         }

  //     });

  //     userSuggestionData(driverDetails);
  //     setSuggestions([]);
  //   };
  //   const userSuggestionData = (passenger)=>{

  //     var inputs = document.querySelectorAll('.my-3');
  //        for (var i = 0; i < inputs.length; i++) {
  //            //inputs[i].value = passenger[i] || '';
  //            if (typeof passenger[i] === 'string') {
  //                inputs[i].value = passenger[i];
  //              } else if (typeof passenger[i] === 'object') {
  //                inputs[i].value = passenger[i].text || '';
  //              } else {
  //                inputs[i].value = '';
  //              }
  //        }
  //    }

  // const onChangeHandler = (e)=>{
  //     //console.log('Key up event triggered:', e.target);
  //     let text = e.target.value ? e.target.value : "";
  //     let inputIndex = e.target.dataset.index;
  //     localStorage.setItem('InputIndex',inputIndex);
  //     //console.log( e.target);
  //         let matches = [];
  //         if(text.length > 0){
  //             matches = driverDetails.filter(user =>{
  //                 const regex = new RegExp(`${text}`,"gi");
  //                 return user.first_name.match(regex) || user.user_id.toString().match(regex);
  //             })
  //         }
  //         setSuggestions(matches);
  //        //console.log(matches);
  //   }
  const handleKeyDown = (e) => {
    const value = e.target.value;
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    const isNumberKey = /^[0-9]$/.test(e.key);
    if (
      (!isNumberKey && !allowedKeys.includes(e.key)) ||
      (e.target.value.length >= 8 && !allowedKeys.includes(e.key))
    ) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div
        className="tab-pane fade active show"
        id="add-passenger"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <section>
          <div className="d-flex justify-content-between form-container">
            <div>
              <h2 className="fs-5 font-weight-600"> Add Passenger</h2>
            </div>
            <div>
              <span>{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <section>
          <div className="bg-white  px-5 py-4">
            <div>
              <p className="sub-title">Personal Information</p>
            </div>
            <form onSubmit={handleFormSubmit} ref={formRef}>
              <div className="form-items">
                <div>
                  <label className="require-field">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="first_name"
                    name="first_name"
                    placeholder=""
                    onChange={handleInputChange}
                  />
                  {errors.first_name && (
                    <span className="errors">{errors.first_name}</span>
                  )}
                </div>
                <div>
                  <label>Middle Name</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="middle_name"
                    name="middle_name"
                    placeholder=""
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <label className="require-field">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="last_name"
                    name="last_name"
                    placeholder=""
                    onChange={handleInputChange}
                  />
                  {errors.last_name && (
                    <span className="errors">{errors.last_name}</span>
                  )}
                </div>
                <div>
                  <label>Preferred Name</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="preferred_name"
                    name="preferred_name"
                    placeholder=""
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <label className="require-field">Gender</label>
                  <div>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      name="gender"
                      onChange={handleInputChange}
                    >
                      <option value="">Select</option>
                      <option value="1">Male</option>
                      <option value="2">Female</option>
                    </select>
                  </div>
                  {errors.gender && (
                    <span className="errors">{errors.gender}</span>
                  )}
                </div>
                <div className="date-selector">
                  <label className="require-field">Date of Birth</label>
                  <Calender
                    selected={birthDate}
                    onChange={handleInputChange}
                    setDate={setBirthDate}
                    name="date_of_birth"
                    id="date_of_birth"
                    isClearable={false}
                    errors={errors.date_of_birth}
                  />
                </div>
                {/* <div>
                            <label>Insurance Number</label>
                            <input 
                            type="text" 
                            className="form-control" 
                            autoComplete='off' 
                            id="insurance_number" 
                            name="insurance_number" 
                             onKeyDown={allowOnlyNumberKey}
                            onChange={handleInputChange} />
                        </div> */}
                <div>
                  <label className="require-field">
                    Member ID/Insurance Number
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    autoComplete="off"
                    id="pmi_number"
                    name="pmi_number"
                    onChange={handleInputChange}
                    // onKeyDown={handleKeyDown}
                  />
                  {errors.pmi_number && (
                    <span className="errors">{errors.pmi_number}</span>
                  )}
                </div>
                <div>
                  <label className="require-field">Payor</label>
                  {/* <input type="text" className="form-select" autoComplete='off' id="payer" name="payer" placeholder="" onChange={handleInputChange} /> */}
                  <select
                    className="form-select"
                    id="payer"
                    name="payer"
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    {payerList.map((payer, index) => (
                      <option key={index} value={payer.id}>
                        {payer.payer_name}
                      </option>
                    ))}
                  </select>
                  {errors.payer && (
                    <span className="errors">{errors.payer}</span>
                  )}
                </div>
                <div>
                  <label>Location</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="location"
                    name="location"
                    placeholder=""
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <label className="require-field">Address Line 1</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="address_line_one"
                    name="address_line_one"
                    placeholder=""
                    onChange={handleInputChange}
                  />
                  {errors.address_line_one && (
                    <span className="errors">{errors.address_line_one}</span>
                  )}
                </div>
                <div>
                  <label>Address Line 2</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="address_line_two"
                    name="address_line_two"
                    placeholder=""
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <label className="require-field">City</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="city"
                    name="city"
                    onChange={handleInputChange}
                  />
                  {errors.city && <span className="errors">{errors.city}</span>}
                </div>
                <div>
                  <label className="require-field">State</label>
                  <select
                    className="form-select"
                    onChange={handleInputChange}
                    aria-label="Default select example"
                    id="state"
                    name="state"
                  >
                    <option value="">Select</option>
                    {stateData.map((state, index) => (
                      <option key={index} value={state.state_id}>
                        {state.state_name}
                      </option>
                    ))}
                  </select>
                  {errors.state && (
                    <span className="errors">{errors.state}</span>
                  )}
                </div>
                <div>
                  <label>County</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    id="county"
                    name="county"
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <label className="require-field">Zip</label>
                  <input
                    type="text"
                    className="form-control"
                    onInput={restrictZipInput}
                    autoComplete="off"
                    id="zip"
                    name="zip"
                    onChange={handleInputChange}
                  />
                  {errors.zip && <span className="errors">{errors.zip}</span>}
                </div>
                <div>
                  <label>Home Phone Number</label>
                  <InputMask
                    className="form-control"
                    autoComplete="off"
                    mask="(999) 999-9999"
                    id="home_phone"
                    name="home_phone"
                    onChange={handleInputChange}
                  ></InputMask>
                  {errors.home_phone && (
                    <span className="errors">{errors.home_phone}</span>
                  )}
                </div>
                <div>
                  <label className="require-field">Cell Phone Number</label>
                  {/* <input type="text" className="form-control"  id="cell_phone" name="cell_phone" onChange={handleInputChange} placeholder="(612) 726-5555" /> */}
                  <InputMask
                    className="form-control"
                    mask="(999) 999-9999"
                    id="cell_phone"
                    autoComplete="off"
                    name="cell_phone"
                    onChange={handleInputChange}
                  ></InputMask>
                  {errors.cell_phone && (
                    <span className="errors">{errors.cell_phone}</span>
                  )}
                  {/* <div className="form-check pt-2">
                                <input className="form-check-input"
                                    type="checkbox" value="" id="pick-up-phone" name="pick_phone" ref={checkboxRef}
                                    onChange={handleInputChange} />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Pick Up Phone
                                </label>
                            </div> */}
                </div>
                <div>
                  <label>Alternate Phone Number</label>
                  <InputMask
                    className="form-control"
                    autoComplete="off"
                    mask="(999) 999-9999"
                    id="alternative_phone"
                    name="alternative_phone"
                    onChange={handleInputChange}
                  ></InputMask>
                </div>
                <div className="form-item">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="add_username_password"
                      checked={addUsernamePassword}
                      onChange={handleAddUsernamePasswordChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="add_username_password"
                    >
                      Add email, username and password
                    </label>
                  </div>
                </div>
                {addUsernamePassword && (
                  <>
                    <div className="form-item">
                      <label className="require-field">Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        autoComplete="off"
                        onChange={handleInputChange}
                        id="email_address"
                        name="email_address"
                        value={passengerDetails.email_address}
                      />
                      {errors.email_address && (
                        <span className="errors">{errors.email_address}</span>
                      )}
                    </div>
                    <div className="form-item">
                      <label className="require-field">Username</label>
                      <input
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        onChange={handleInputChange}
                        id="username"
                        name="username"
                        value={passengerDetails.username}
                      />
                      {errors.username && (
                        <span className="errors">{errors.username}</span>
                      )}
                    </div>
                    <div className="form-item">
                      <label className="require-field">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        autoComplete="off"
                        onChange={handleInputChange}
                        id="password"
                        name="password"
                        value={passengerDetails.password}
                      />
                      {errors.password && (
                        <span className="errors">{errors.password}</span>
                      )}
                    </div>
                  </>
                )}
                <div>
                  <label>Home Type</label>
                  <div>
                    <select
                      className="form-select"
                      onChange={handleInputChange}
                      aria-label="Default select example"
                      id="home_type"
                      name="home_type"
                    >
                      <option value="">Select</option>
                      <option value="1">Residence</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Mode</label>
                  <div>
                    <select
                      className="form-select"
                      onChange={handleInputChange}
                      aria-label="Default select example"
                      id="mode"
                      name="mode"
                    >
                      <option value="">Select</option>
                      <option value="1">Option 1</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Weight</label>
                  <input
                    type="text"
                    onChange={handleInputChange}
                    autoComplete="off"
                    className="form-control"
                    id="weight"
                    name="weight"
                  />
                </div>
                <div className="date-selector">
                  <label>WC Expiry Date</label>
                  <Calender
                    selected={startDate}
                    onChange={handleInputChange}
                    setDate={setStartDate}
                    name="wc_expiry_date"
                    id="wc_expiry_date"
                    errors={errors.wc_expiry_date}
                  />
                </div>
                <div>
                  <label>Visit Frequency</label>
                  <div>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      name="visit_frequency"
                      onChange={handleInputChange}
                    >
                      <option value="1">Recurring</option>
                      <option value="2">One Time</option>
                    </select>
                  </div>
                </div>

                <div className="d-flex gap-3 ">
                  <div>
                    <label htmlFor="oxygen">Oxygen</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      autoComplete="off"
                      type="radio"
                      onChange={handleInputChange}
                      value="0"
                      id="oxy_yes"
                      name="oxy"
                    />
                    <label className="form-check-label">Yes</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      autoComplete="off"
                      onChange={handleInputChange}
                      type="radio"
                      value="1"
                      id="oxy_no"
                      name="oxy"
                    />
                    <label className="form-check-label">no</label>
                  </div>
                </div>
                <div className="d-flex gap-3 ">
                  <div>
                    <label htmlFor="oxygen">Bariatric</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      autoComplete="off"
                      onChange={handleInputChange}
                      type="radio"
                      value="0"
                      name="bari"
                    />
                    <label className="form-check-label">Yes</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      autoComplete="off"
                      onChange={handleInputChange}
                      type="radio"
                      value="1"
                      name="bari"
                    />
                    <label className="form-check-label">no</label>
                  </div>
                </div>
              </div>
              <div className="my-4">
                <p className="sub-title">Emergency Contact Information</p>
                <div className="form-items">
                  <div>
                    <label>First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      onChange={handleInputChange}
                      id="e_first_name"
                      name="e_first_name"
                    />
                  </div>
                  <div>
                    <label>Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      onChange={handleInputChange}
                      id="e_last_name"
                      name="e_last_name"
                    />
                  </div>
                  <div>
                    <label>Cell Phone Number</label>
                    <InputMask
                      className="form-control"
                      autoComplete="off"
                      mask="(999) 999-9999"
                      id="e_cell_number"
                      name="e_cell_number"
                      onChange={handleInputChange}
                    ></InputMask>
                  </div>
                  <div className="form-item">
                    <label>Email Address</label>
                    <input
                      type="email"
                      autoComplete="off"
                      className="form-control"
                      onChange={handleInputChange}
                      id="e_email"
                      name="e_email"
                    />
                  </div>
                </div>
              </div>
              <div className="pb-3">
                <p className="sub-title">Responsible Party Information</p>
                <div className="form-items">
                  <div>
                    <label>First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      onChange={handleInputChange}
                      id="r_first_name"
                      name="r_first_name"
                    />
                  </div>
                  <div>
                    <label>Last Name</label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      onChange={handleInputChange}
                      id="r_last_name"
                      name="r_last_name"
                    />
                  </div>
                  <div>
                    <label>Cell Phone Number</label>
                    <InputMask
                      className="form-control"
                      autoComplete="off"
                      mask="(999) 999-9999"
                      id="r_cell_number"
                      name="r_cell_number"
                      onChange={handleInputChange}
                    ></InputMask>
                  </div>
                  <div className="form-item">
                    <label>Email Address</label>
                    <input
                      type="email"
                      autoComplete="off"
                      className="form-control"
                      onChange={handleInputChange}
                      id="r_email"
                      name="r_email"
                    />
                  </div>
                </div>
              </div>

              <div className="my-4">
                <p className="sub-title">Billing Information</p>
                <div className="form-items">
                  <div>
                    <label>Diagnosis Code</label>
                    <div>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="diagnosis_code"
                        onChange={handleInputChange}
                      >
                        <option value="Z00.8">Z00.8</option>
                        <option value="Z02.89">Z02.89</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="footer-content">
                {/* <button type='submit' className='btn save-btn default-btn add-passenger-btn'>Save Passenger</button> */}

                <SaveButton
                  type="submit"
                  buttonTitle={"ADD PASSENGER"}
                  loading={isAddingPassenger}
                  loadingText="ADDING..."
                />

                {/* <CancelButton cancelHandler={() => navigate('list')} /> */}
              </div>
            </form>
          </div>
        </section>
        {/* <div>
       <Auto/>
    </div> */}
      </div>
      <div> {loading && <Loader />}</div>
    </>
  );
};
export default Passenger;
